import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Message } from "@arco-design/web-react";
import { PostApi } from "../Api/AuthenticatedApi";
import FileAssetPicker from "./FileAssetPicker";

// Picks an image from the org's file assets (or uploads a new one) and hands
// back a permanent public URL for it. File assets are private; choosing one
// here publishes just that image (POST /api/files/:name/public-link), which is
// what lets it show on a form embedded on someone else's site.
export default function ImagePicker({ visible, onCancel, onPick }) {
    const { getAccessTokenSilently } = useAuth0();

    const publish = (name) => new Promise((resolve, reject) => {
        PostApi(getAccessTokenSilently, "/api/files/" + encodeURIComponent(name) + "/public-link",
            (data) => { onPick({ url: data.url, fileName: data.file_name }); resolve(); },
            reject,
            (err) => { Message.error((err && err.message) || "Failed to use that image"); reject(err); },
            {});
    });

    return (
        <FileAssetPicker
            visible={visible}
            onCancel={onCancel}
            onSelect={publish}
            title="Choose an image"
            imagesOnly
            accept="image/*"
            note="The image you choose becomes publicly viewable (so it can show on your form). Your other files stay private. Large images are shrunk so the form loads fast."
        />
    );
}
